/** @jsx jsx */
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import React, { Fragment, useMemo, useRef, useState } from 'react'
import { TotalTabWrap } from '@styles/base.style'
import { ListView, Tabs } from 'antd-mobile'
import { Models } from 'rmc-tabs/lib/Models'
import useRootStore from '@store/useRootStore'
import { useOnMount, useOnUnmount } from '@utils/reactExt'
import _ from 'lodash'
import { SPORT_ID_ICON_MAP } from '@shared/SportIdGroup'
import { HitStateSuccessCount, PickList, UserPickPopoverWrap } from '@views/Home/index.style'
import { Schema$UserPickExtend, Schema$UserPickRecentMatchPackage, Schema$UserPickUserInfo } from '@interface/user-pick'
import { BET_HIT_STATE, SPORT_ID } from 'adv-protocol/src/GameCommon'
import { UserPickItem } from '@views/Home/UserPick/Components/UserPickItem'
import { AdvEmpty } from '@components/AdvEmpty'
import { BET_TICKET_TYPE, EMPTY_ICON, GIFT_BTN_TYPE } from '@constants/index'
import { AdvButton } from '@components/Button'
import { BlockBtn, UserDetailPopup, UserInfoBtnStyle } from '@views/Popup/UserDetailInfo/index.style'
import { UserPickProfile } from '@views/Home/UserPick/Components/UserPickProfile'
import { USER_PICK_SPECIFIC_TYPE } from '@v2/constants/user-pick'
// import { UserPickSpecialMemberMark } from '@views/Home/UserPick/Components/UserPickSpecialMemberMark'
import classNames from 'classnames'
import { SendbetCouponIco, SendHeartIco } from '@shared/Icon/EtcIcon'
import ProfileSoccerBg from '@assets/images/bg/profile/soccer.jpg'
import ProfileBasketballBg from '@assets/images/bg/profile/basketball.jpg'
import ProfileBaseballBg from '@assets/images/bg/profile/baseball.jpg'
import ProfileVolleyballBg from '@assets/images/bg/profile/volleyball.jpg'
import ProfileIceHockeyBg from '@assets/images/bg/profile/ice_hockey.jpg'
import ProfileTableTennisBg from '@assets/images/bg/profile/table_tennis.jpg'
import ProfileDefaultBg from '@assets/images/bg/profile/default.jpg'
import ProfileTodayUserPIckTxtImg from '@assets/images/text/profile-today-user-pick-txt.png'
import BettorGiftContentPopup from '@views/Popup/BettorGiftContentPopup'
import MessageContentPopup from '@views/Popup/MessageContentPopup'
import { COMMUNICATION_BLOCK_TYPE, FROM_VIEW_TYPE, GlobalStoreKey } from '@v2/constants/common'
import { getTicketCountFromTicket } from '@utils/utils'
import { isMobile } from 'react-device-detect'
import dayjs from 'dayjs'
import CommentAddImg from '@assets/images/btn/comment-add-btn.png'
import { Button } from '@styles/button.style'
import { Popover } from 'antd'
import DialogUtils from '@utils/dialog-utils'
import { runInAction } from 'mobx'
import { UserTitle } from '@components/UserTitle'
import { bettingHistoryStore, userStore } from '@store/index'
import { UnderOverArrowIco } from '@shared/Icon/ArrowIcon'
import FavoriteImg from '@assets/images/btn/favorite-manage.png'
import FavoriteActiveImg from '@assets/images/btn/favorite-manage-mono-active.png'

interface UserDetailInfoProps {
  targetUserPromiseId: string
  initTabIndex?: number
}

const dataSource = new ListView.DataSource({
  rowHasChanged: (row1, row2) => row1 !== row2,
})

export const UserDetailInfo: React.FC<UserDetailInfoProps> = observer((props): React.ReactElement => {
  const {
    userPickStore,
    authStore,
    componentStore,
    bettorStore,
    globalStore,
  } = useRootStore()
  const {
    userPickRecentMatchPackage = {} as Schema$UserPickRecentMatchPackage,
    userPickSpecificMemberPicks,
    userPickSpecificMemberPickHasMore,
    userPickSpecificMemberPickCountMap = {} as Record<USER_PICK_SPECIFIC_TYPE, number>,
  } = userPickStore
  const {
    userInfo = {} as Schema$UserPickUserInfo,
    recentMatches,
    hitStateSuccessCount,
    hitStateFailCount,
  } = userPickRecentMatchPackage
  const currentUserId = authStore?.userInfo.id

  const { targetUserPromiseId, initTabIndex = 0 } = props

  const [currentTabKey, setCurrentTabKey] = useState(USER_PICK_SPECIFIC_TYPE.TOTAL)
  const [visibleMessageSend, setVisibleMessageSend] = useState(false)
  const [visibleHeartSend, setVisibleHeartSend] = useState(false)
  const favoriteAlarmPendingRef = useRef(false)
  const favoriteAlarmProcessedRef = useRef(false)
  const profile = userInfo.userProfileImg
  const receiveId = userInfo.userPromiseId
  const nick = userInfo.userNick
  const customProfile = userInfo.isCustomProfileImg
  const isFavoriteUser = userInfo.isFavoriteUser

  let showSendTicket = false
  let showSendHeart = false
  const ticket_value = globalStore.findGlobalSetting(GlobalStoreKey.GIFT_TICKET_ON_OFF)
  const heart_value = globalStore.findGlobalSetting(GlobalStoreKey.GIFT_HEART_ON_OFF)
  if (ticket_value) {
    showSendTicket = ticket_value.value !== '0'
  }
  if (heart_value) {
    showSendHeart = heart_value.value !== '0'
  }

  if (showSendTicket) {
    showSendTicket = getTicketCountFromTicket(BET_TICKET_TYPE.BET_TICKET1, authStore.userInfo.ticket) > 0
  }

  if (showSendHeart) {
    showSendHeart = authStore.userInfo.heart > 0
  }

  const fetch = (tabKey: USER_PICK_SPECIFIC_TYPE, reset = false) => {
    userPickStore.fetchUserPickSpecificMemberPicks(targetUserPromiseId, tabKey, reset).catch(console.error)
  }

  useOnMount(() => {
    userPickStore.fetchUserPickSpecificUserPackage(targetUserPromiseId).catch(console.error)
  })

  useOnUnmount(() => {
    userPickStore.resetUserPickRecentMatchPackage()
    userPickStore.resetUserPickSpecificMemberPicks(true)
    bettorStore.setGiftBtnType(null)
  })

  const hitStateCount = hitStateSuccessCount ? (hitStateSuccessCount + hitStateFailCount) : 0

  const userActivityTabList: Models.TabData[] = useMemo(() => {
    return [
      {
        title: (
          <span className="tab-item">
            <span className="txt">전체</span>
            <span className="num">{userPickSpecificMemberPickCountMap[USER_PICK_SPECIFIC_TYPE.TOTAL]}</span>
          </span>
        ),
        name: '전체',
        key: USER_PICK_SPECIFIC_TYPE.TOTAL.toString(),
      },
      {
        title: (
          <span className="tab-item">
            <span className="txt">적중한 글</span>
            <span className="num">{userPickSpecificMemberPickCountMap[USER_PICK_SPECIFIC_TYPE.HIT_PICK]}</span>
          </span>
        ),
        name: '적중한 글',
        key: USER_PICK_SPECIFIC_TYPE.HIT_PICK.toString(),
      },
      {
        title: (
          <span className="tab-item">
            <span className="txt">오늘의 승부사</span>
            <span className="num">{userPickSpecificMemberPickCountMap[USER_PICK_SPECIFIC_TYPE.BEST_PICK]}</span>
          </span>
        ),
        name: '오늘의 승부사',
        key: USER_PICK_SPECIFIC_TYPE.BEST_PICK.toString(),
      },
    ]
  }, [userPickSpecificMemberPickCountMap])

  const onChangeTab = (tab: Models.TabData) => {
    setCurrentTabKey(Number(tab.key) as USER_PICK_SPECIFIC_TYPE)
    fetch(Number(tab.key) as USER_PICK_SPECIFIC_TYPE, true)
  }

  const hitStateToStr = (hitState: BET_HIT_STATE): string => {
    switch (hitState) {
      case BET_HIT_STATE.SUCCESS:
        return 'success'
      case BET_HIT_STATE.CANCEL:
        return 'cancel'
      case BET_HIT_STATE.FAIL:
        return 'fail'
    }
  }

  const onClickHeartButton = (): void => {
    bettorStore.setGiftBtnType(GIFT_BTN_TYPE.HEART)
    setVisibleHeartSend(true)
  }
  const onClickTicketButton = (): void => {
    bettorStore.setGiftBtnType(GIFT_BTN_TYPE.TICKET)
    setVisibleHeartSend(true)
  }
  const onClickFavoredUsersButton = async (): Promise<void> => {
    if (!userInfo.isFavoriteUser) {
      if (favoriteAlarmPendingRef.current) {
        return
      }
      const shouldSendFavoriteAlarm = !favoriteAlarmProcessedRef.current
      favoriteAlarmPendingRef.current = true
      const added = await userStore.addFavoriteUsers({
        userPromiseIds: [userInfo.userPromiseId],
        favoriteRegistrationAlarmUserPromiseId: shouldSendFavoriteAlarm ? userInfo.userPromiseId : undefined,
      })
      favoriteAlarmPendingRef.current = false
      if (added && shouldSendFavoriteAlarm) {
        favoriteAlarmProcessedRef.current = true
      }
    } else {
      await userStore.removeFavoriteUsers({ userPromiseIds: [userInfo.userPromiseId] })
    }
  }
  const onClickSendMessageButton = (): void => {
    bettingHistoryStore.resetSelectedBettingHistory(FROM_VIEW_TYPE.USER_DETAIL_INFO)
    bettingHistoryStore.setBettingHistoryInitProps({
      onlyMajorClub: false,
      fromViewType: FROM_VIEW_TYPE.USER_DETAIL_INFO,
    })
    componentStore.setExtraClubId(null)
    setVisibleMessageSend(true)
  }

  const onUserBlockSuccessHandler = (userPromiseId: string, blockTypes: COMMUNICATION_BLOCK_TYPE[]) => {
    if (!_.eq(userInfo.userPromiseId, userPromiseId)) {
      return
    }

    const isUserBlock = !_.isEmpty(componentStore.selectedUserCommunicationBlocks)
    const isPickBlock = _.includes(componentStore.selectedUserCommunicationBlocks, COMMUNICATION_BLOCK_TYPE.USER_PICK)

    runInAction(() => {
      userInfo.isBlocked = isUserBlock

      userPickStore.userPickSpecificMemberPicks = userPickStore.setUserBlock(
        userPickSpecificMemberPicks,
        userPromiseId,
        isUserBlock,
        isPickBlock,
      )
    })
  }

  const makeHitRate = (): string => {
    if (hitStateCount <= 0) {
      return '0%'
    }
    return `${Math.floor((hitStateSuccessCount / hitStateCount) * 100)}%`
  }
  const recentPercent = hitStateSuccessCount / hitStateCount

  const topRankRate = 0.8
  const middleRankRate = 0.5

  const recentHitRateClass = classNames(
    'recent-hit-rate',
    { 'effect': recentPercent >= topRankRate },
    { 'color': recentPercent >= middleRankRate },
  )

  const isMine = currentUserId === targetUserPromiseId
  const ProfileSportsImgSrc = useMemo<string>(() => {
    if (_.isEmpty(recentMatches)) {
      return ProfileDefaultBg
    }

    const tempData: { sportId: number, count: number, lastIdx: number }[] = []
    for (const idx in recentMatches) {
      const recentMatch = recentMatches[idx]
      const exists = _.find(tempData, { sportId: recentMatch.sportId })
      if (exists) {
        exists.count += 1
      } else {
        tempData.push({ sportId: recentMatch.sportId, count: 1, lastIdx: Number(idx) })
      }
    }
    let maxValue: { sportId: number, count: number, lastIdx: number }
    for (const temp of tempData) {
      if (_.isNil(maxValue)) {
        maxValue = temp
      } else if (maxValue.count < temp.count) {
        maxValue = temp
      } else if (maxValue.count === temp.count && maxValue.lastIdx > temp.lastIdx) {
        maxValue = temp
      }
    }
    switch (maxValue.sportId) {
      case SPORT_ID.SOCCER:
        return ProfileSoccerBg
      case SPORT_ID.BASKETBALL:
        return ProfileBasketballBg
      case SPORT_ID.BASEBALL:
        return ProfileBaseballBg
      case SPORT_ID.VOLLEYBALL:
        return ProfileVolleyballBg
      case SPORT_ID.ICE_HOCKEY:
        return ProfileIceHockeyBg
      case SPORT_ID.TABLE_TENNIS:
        return ProfileTableTennisBg
      default:
        return ProfileDefaultBg
    }
  }, [recentMatches])

  const profileSportsBg = useMemo(() => {
    if (_.isNil(recentMatches)) {
      return <div className="bg-img skeleton"/>
    } else {
      return <img src={ProfileSportsImgSrc} alt="프로필 팝업 배경" className="bg-img"/>
    }
  }, [recentMatches])

  let fromProfileImg = profile
  if (profile?.indexOf('randomuser.me/api/portraits/men/46.jpg') > -1) {
    fromProfileImg = 'https://d1i7hydgfclv7m.cloudfront.net/data_center/item_image_m/FB24E425-3167-4AA6-AC12-56CA9DECEC7A.png'
  }

  const onClickViewUserProfileImg = (imageSrc: string, userNick: string) => {
    DialogUtils.showImagePreview({ imageSrc, imageAlt: '프로필 이미지' })
  }


  const isUserBlockEanbled = globalStore.getUserBlockEnabled()
  const isPossibleUserBlock = globalStore.isPossibleUserBlockByUserPromiseId(userInfo?.userPromiseId || '')
  const userBlock = userInfo.isBlocked

  const onClickBlockUser = (): void => {
    const { userPromiseId, userNick, userProfileImg } = userInfo
    if (!userBlock) {
      DialogUtils.showUserBlock(userPromiseId, userNick, userProfileImg, onUserBlockSuccessHandler)
    } else {
      DialogUtils.showUserUnBlock(userPromiseId, onUserBlockSuccessHandler)
    }
  }

  const popoverContent = (
    <UserPickPopoverWrap>
      <Fragment>
        <Button TP className={userBlock ? 'popover-btn delete' : 'popover-btn'} onClick={onClickBlockUser}>
          {userBlock ? '차단해제' : '차단하기'}
        </Button>
      </Fragment>
    </UserPickPopoverWrap>
  )

  let profileHeaderInfoContents: React.ReactNode
  const SkeletonProfileHeaderInfoContents = (
    <div className="profile skeleton">
      <div className="profile-img-wrap gray-skeleton"></div>
    </div>
  )

  if (!_.isEmpty(userInfo)) {
    profileHeaderInfoContents = <UserPickProfile userInfo={userInfo} userTitleEnabled={false}/>
  } else {
    profileHeaderInfoContents = SkeletonProfileHeaderInfoContents
  }

  const renderHeader = (): React.ReactElement => {
    return (
      <Fragment>
        <div className="profile-bg">
          {profileSportsBg}
          <div className="shadow"/>
          <BlockBtn>
            {!isMine && isUserBlockEanbled && isPossibleUserBlock && (
              <Popover
                placement="bottomLeft"
                content={popoverContent}
                trigger={isMobile ? 'click' : 'hover'}
                mouseLeaveDelay={0.05}
                overlayClassName={'user-comment-menu'}
                getPopupContainer={(triggerNode: any) => triggerNode.parentNode}
              >
                <Button TP className="extra-btn">
                  <img src={CommentAddImg} alt="댓글 추가버튼" style={{ width: 3 }} loading="lazy"/>
                </Button>
              </Popover>
            )}
          </BlockBtn>
        </div>
        <article className={isMobile ? 'profile-header' : 'profile-header pc'}>
          <div className="profile-header--info">
            <AdvButton
              contents={profileHeaderInfoContents}
              onClick={() => onClickViewUserProfileImg(fromProfileImg, userInfo.userNick)}
            />
            <div css={{ flex: 1 }}>
              <div className="nickname">
                {userInfo.userNick}
                {/* 칭호기능 추가로 인해 위치 변경*/}
                {/*<UserPickSpecialMemberMark showSMark={userInfo.hasMark} small/>*/}
              </div>
              {<UserTitle showSMark={userInfo.hasMark}
                          isSpecialMember={userInfo.isSpecialMember}
                          userTitleId={userInfo.userTitleId}
                          userTitleEnabled={userInfo.userTitleEnabled}
                          myPageMode={false}/>}
            </div>
          </div>
          {!isMine && (
            <div className="btn-wrap">
              <AdvButton
                flex
                alignCenter
                darkgray
                text={['메시지 보내기']}
                color="darkTxt"
                css={UserInfoBtnStyle}
                className="send-message-btn"
                onClick={onClickSendMessageButton}
              />
              {showSendHeart && (
                <AdvButton
                  flex
                  alignCenter
                  darkgray
                  width={44}
                  margin={'0 0 0 9px'}
                  ico={<SendHeartIco/>}
                  icoSize={28}
                  css={UserInfoBtnStyle}
                  onClick={onClickHeartButton}
                />
              )}
              {showSendTicket && (
                <AdvButton
                  flex
                  alignCenter
                  darkgray
                  width={44}
                  margin={'0 0 0 9px'}
                  ico={<SendbetCouponIco/>}
                  icoSize={28}
                  css={UserInfoBtnStyle}
                  onClick={onClickTicketButton}
                />
              )}
              <AdvButton
                flex
                alignCenter
                darkgray
                width={44}
                margin={'0 0 0 9px'}
                img={isFavoriteUser ? FavoriteActiveImg : FavoriteImg}
                icoSize={18}
                css={UserInfoBtnStyle}
                onClick={onClickFavoredUsersButton}
              />
            </div>
          )}
        </article>

        <article className="user-pick-warp">
          <h2 className="tit">나도 승부사</h2>

          <div className="monthly-today-pick">
            <span className="month">{dayjs().format('M')}월</span>
            <img src={ProfileTodayUserPIckTxtImg} alt="오늘의 승부사" className="today-txt-img"/>
            {userInfo.monthlyBestPickCount}회
          </div>

          <div className="hit-state-table">

            <div className="table-wrap">
              <div className="table-box">
                <span className="table-line"/>
                <span className="table-line"/>
                <span className="table-line"/>
                <span className="table-line"/>
                <span className="table-line"/>
                <span className="table-line"/>
                <span className="table-line"/>
                <span className="table-line"/>
                <span className="table-line"/>
                <span className="table-line"/>
              </div>

              <ul className="table">
                {_.map(recentMatches, (item, index) => {
                  const isLastItem = index === 0

                  return (
                    <li key={item.id} className={`table--item ${hitStateToStr(item.hitState)}`}>
                      {isLastItem && <UnderOverArrowIco/>}
                      <div className="result">
                        {SPORT_ID_ICON_MAP[item.sportId]}
                        <span className="circle"/>
                      </div>
                    </li>
                  )
                })}
              </ul>
            </div>

            <div className="sub-info">
              {hitStateCount}경기 적중률
              <HitStateSuccessCount className="hit-state-success-count">
                <div className={recentHitRateClass}>
                  {makeHitRate()}
                </div>
                {recentPercent >= topRankRate &&
                  <Fragment>
                    <span className="light big">{makeHitRate()}</span>
                    <span className="light">{makeHitRate()}</span>
                  </Fragment>
                }
              </HitStateSuccessCount>
            </div>

            <ul className="state-list">
              <li className="state-list--item">
                <span className="circle success"/>
                적중
              </li>
              <li className="state-list--item">
                <span className="circle fail"/>
                미적중
              </li>
              <li className="state-list--item">
                <span className="circle cancel"/>
                적특
              </li>
            </ul>
          </div>
        </article>

        <TotalTabWrap underline>
          <Tabs
            tabs={userActivityTabList}
            initialPage={initTabIndex}
            page={currentTabKey}
            onChange={onChangeTab}
          />
        </TotalTabWrap>
      </Fragment>
    )
  }

  const renderRow = (row: Schema$UserPickExtend): React.ReactElement => {
    return <UserPickItem
      userPick={row}
      disableUserInfoClick
      showMatchInfoSimple
      onUserBlockSuccessHandler={onUserBlockSuccessHandler}
    />
  }

  const renderFooter = (): React.ReactElement => {
    if (!_.isEmpty(userPickSpecificMemberPicks)) {
      return <Fragment/>
    }
    let footer
    switch (currentTabKey) {
      case USER_PICK_SPECIFIC_TYPE.TOTAL:
        footer = <AdvEmpty ico={EMPTY_ICON.USER_PICK_ACTIVITY}/>
        break
      case USER_PICK_SPECIFIC_TYPE.HIT_PICK:
        footer = <AdvEmpty ico={EMPTY_ICON.USER_HIT_PICK_LIST}/>
        break
      case USER_PICK_SPECIFIC_TYPE.BEST_PICK:
        footer = <AdvEmpty ico={EMPTY_ICON.TODAY_USER_PICK_LIST}/>
        break
    }

    return <div css={{ textAlign: 'center' }}>{footer}</div>
  }

  const endReachedHandler = () => {
    if (userPickSpecificMemberPickHasMore) {
      fetch(currentTabKey)
    }
  }

  return (
    <UserDetailPopup>
      <PickList className="user-pick-detail-popup-list">
        <ListView
          css={{ height: '100%' }}
          dataSource={dataSource.cloneWithRows(userPickSpecificMemberPicks)}
          renderHeader={renderHeader}
          renderRow={renderRow}
          scrollRenderAheadDistance={500}
          renderFooter={renderFooter}
          onEndReached={endReachedHandler}
          onEndReachedThreshold={10}
          initialListSize={9}
          pageSize={9}
        />
      </PickList>
      <BettorGiftContentPopup
        visible={visibleHeartSend}
        setVisible={setVisibleHeartSend}
        nick={nick}
        isCustomProfile={customProfile}
        profile={profile}
      />
      <MessageContentPopup
        visible={visibleMessageSend}
        setVisible={setVisibleMessageSend}
        receive={{
          id: receiveId,
          nick,
          title: '',
        }}
        action={'send'}
        useRequestWaitTimer
        fromViewType={FROM_VIEW_TYPE.USER_DETAIL_INFO}
      />
    </UserDetailPopup>
  )
})
